// src/components/ServiceRecordCard.js

import React, { useState, useEffect, useRef } from 'react';
import { Typography, Box, IconButton, Menu, MenuItem, Divider, Button } from '@mui/material'; // Removed Paper
import { useNavigate } from 'react-router-dom';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HandymanIcon from '@mui/icons-material/Handyman';
import { useAuth } from '../../context/AuthContext';
import { formatDistanceToNow, isPast } from 'date-fns';
import { tr } from 'date-fns/locale';
import GlassCard from '../../ui/glass/components/GlassCard';

const ServiceRecordCard = ({ serviceRecord, statuses, onStatusChange, onMarkAsDelivered }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const [kalanSure, setKalanSure] = useState('');

  // YENİ: Menü ile etkileşimi takip etmek için bir referans
  const menuInteractionRef = useRef(false);

  useEffect(() => {
    if (serviceRecord && serviceRecord.teslimTarihi) {
      const teslimTarihiDate = serviceRecord.teslimTarihi.toDate();
      if (isPast(teslimTarihiDate) && !['Teslime Hazır', 'Tamamlandı', 'Teslim Edildi'].includes(serviceRecord.durum)) {
        setKalanSure("Gecikti");
        return;
      }
      const sure = formatDistanceToNow(teslimTarihiDate, { addSuffix: true, locale: tr });
      setKalanSure(sure);
    }
  }, [serviceRecord]);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    // Menü açılırken, bir menü etkileşimi başladığını işaretle
    menuInteractionRef.current = true;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // Menü kapandığında, bir menü etkileşimi olduğunu işaretlemeye devam et.
    // Bu, menüyü kapatan tıklamanın kart tıklamasını tetiklemesini engeller.
    menuInteractionRef.current = true;
  };

  const handleStatusSelect = (newStatus) => { onStatusChange(serviceRecord.id, newStatus); handleClose(); };

  const handleCardClick = () => {
    // Eğer son eylem menüyü açmak veya kapatmak ise, yönlendirmeyi iptal et.
    if (menuInteractionRef.current) {
      // İşaretçiyi sıfırla ve fonksiyonu sonlandır.
      menuInteractionRef.current = false;
      return;
    }
    navigate(`/servis-kaydi/${serviceRecord.id}`);
  };

  const handleDeliveryClick = (event) => {
    event.stopPropagation();
    onMarkAsDelivered(serviceRecord.id);
  }

  return (
    <GlassCard
      onClick={handleCardClick}
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1, mb: 2,
        textDecoration: 'none',
        color: 'inherit',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          backgroundColor: 'rgba(255,255,255,0.2)'
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <Box sx={{ width: 60, height: 45, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'action.hover', borderRadius: 1, p: 0.5 }}>
            <HandymanIcon color="primary" />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" fontWeight="bold" noWrap>{serviceRecord.cihazSeriNumarasi}</Typography>
            <Typography variant="caption" color="text.secondary" noWrap>{serviceRecord.musteriAdSoyad}</Typography>
          </Box>
        </Box>
        {currentUser?.role !== 'Servis Teknisyeni' && (
          <Box>
            <IconButton size="small" onClick={handleMenuClick}><MoreTimeIcon color="primary" /></IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              {statuses.filter(status => status !== serviceRecord.durum).map(status => (
                <MenuItem key={status} onClick={() => handleStatusSelect(status)}>{status}'a Taşı</MenuItem>
              ))}
            </Menu>
          </Box>
        )}
      </Box>

      <Divider sx={{ my: 0.5 }} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {currentUser && currentUser.role !== 'Servis Teknisyeni' && (
          <Typography variant="body1" fontWeight="bold">
            {(serviceRecord.toplamTutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
          </Typography>
        )}
        <Box sx={{ flexGrow: 1 }} />
        <Typography variant="caption" color={kalanSure === "Gecikti" ? "error.main" : "text.secondary"} fontWeight="bold">
          {kalanSure}
        </Typography>
      </Box>
      {serviceRecord.durum === 'Teslime Hazır' && currentUser && currentUser.role !== 'Servis Teknisyeni' && (
        <Button
          variant="contained"
          color="success"
          size="small"
          startIcon={<CheckCircleIcon />}
          onClick={handleDeliveryClick}
          sx={{ mt: 1 }}
        >
          Cihazı Teslim Et
        </Button>
      )}
    </GlassCard>
  );
};

export default ServiceRecordCard;